import {CreativeTemplate, CreativeTemplateFeature} from '../creativeTemplates.types';
import {TemplateEssentials} from '../../creatives/creatives.types';

function isWeatherSupportedTemplate(template: CreativeTemplate | TemplateEssentials): boolean {
  return template?.features.includes(CreativeTemplateFeature.Weather);
}

export default isWeatherSupportedTemplate;
